import { LightenDarkenColor, checkValue } from 'src/components/common/helper';
import {
  setGlobalButton,
  setFontSizeByModule,
  setGlobalHeading,
  mediaQueries,
} from 'src/components/common/theme/component-styles';
import { brandCss } from 'src/stylesheets/brand';

class ModuleStyles {
  private data = undefined;
  private defaultSetting = undefined;
  constructor(data: any, defaultSetting: any) {
    this.data = data;
    this.defaultSetting = defaultSetting;
  }
  private primaryBtnStyles() {
    const { primaryColour, cTACopyColor } = this.data;
    const primaryDarkColor = LightenDarkenColor(primaryColour, -0.1);
    return `
    .uitk-button-primary, .hotel-deals-slick button.slick-arrow, .hotel-deals-slick .hotel-card .cta a{              
      background-color:${checkValue(primaryColour) ? primaryColour : ''} !important;
      border-color: ${checkValue(primaryColour) ? primaryColour : ''} !important;
      color: ${checkValue(cTACopyColor) ? cTACopyColor : ''} !important;
      &:hover{
        background-color: ${primaryDarkColor} !important;
        border-color: ${primaryDarkColor} !important;
      }
    }
  `;
  }
  private moduleCssOverrides() {
    const {
      style: {
        primaryColour,
        cTACopyColor,
        cTACopyWeight,
        cTACopySize,
        cTAStyle,
        heading2CopySizeDesktop,
        heading2CopySizeMobile,
        heading2CopyWeight,
        moduleHeadingFontStyle,
      },
    } = this.defaultSetting;
    const { showWiderDesktop, moduleSpacing } = this.data;

    const module = 'default';
    const cTACopySizeMap = setFontSizeByModule(module, 'cTACopySize', cTACopySize);
    const cTACopyWizardSizeMap = setFontSizeByModule(module, 'wizardCopySize', cTACopySize);

    /*${setGlobalHeading(
                  heading2CopySizeDesktop,
                  heading2CopySizeMobile,
                  heading2CopyWeight
                )}*/
    return `              
                                                        
                h2.uitk-new-date-picker-month-name.uitk-type-medium{
                  font-size: inherit !important;
                  color: inherit !important;
                }  
                ${
                  checkValue(showWiderDesktop) && showWiderDesktop !== 'False'
                    ? `
                      {
                        .container{ 
                          @media only screen and (min-width: 1441px) {
                            max-width: 80%; 
                          } 
                        }
                      }
                    `
                    : ''
                }
                
                ${setGlobalButton('.btn-global', primaryColour, cTAStyle, cTACopyColor, cTACopySizeMap, cTACopyWeight)}
                
                ${setGlobalButton(
                  '.btn-wizard-global',
                  primaryColour,
                  cTAStyle,
                  cTACopyColor,
                  cTACopyWizardSizeMap,
                  cTACopyWeight
                )}

                ${
                  checkValue(this.defaultSetting?.site?.brand) &&
                  checkValue(this.defaultSetting?.site?.brand) &&
                  (this.defaultSetting?.site?.brand === 'vrbo' || this.defaultSetting?.site?.brand === 'hotels')
                    ? `
                        .btn, .con-btn{ 
                          border-radius: 2500rem !important;
                        }
                    `
                    : ''
                }

                ${
                  checkValue(moduleHeadingFontStyle)
                    ? `
                    h2,
                    .content-tile-v2-section .content-tile-v2 .content-title-v2-title,
                    .vrbo-booking-section .vrbo-heading-wrapper h2 {
                        font-size: ${moduleHeadingFontStyle.fontSize}px !important;
                        line-height: ${moduleHeadingFontStyle.lineHeight}em !important;
                    }
                    .content_v2-module--text-left h2.cms-typo {
                        font-size: 60px !important;
                        line-height: ${moduleHeadingFontStyle.lineHeight}em !important;
                    }
                    .content_v8-module--text-left h2.cms-typo {
                      font-size: 60px !important;
                      line-height: ${moduleHeadingFontStyle.lineHeight}em !important;
                    }
                    @media only screen and (max-width: ${mediaQueries.tab}) {
                        h2,
                        .content-tile-v2-section .content-tile-v2 .content-title-v2-title,
                        .vrbo-booking-section .vrbo-heading-wrapper h2 {
                            font-size: ${moduleHeadingFontStyle.fontSizeMobile}px !important;
                            line-height: ${moduleHeadingFontStyle.lineHeightMobile}em !important;
                        }
                        .content_v2-module--text-left h2.cms-typo {
                            font-size: 41px !important;
                            line-height: ${moduleHeadingFontStyle.lineHeightMobile}em !important;
                        }
                        .content_v8-module--text-left h2.cms-typo {
                          font-size: 41px !important;
                          line-height: ${moduleHeadingFontStyle.lineHeightMobile}em !important;
                      }
                    }
                `
                    : `
                    h2 {
                
                    }            
                    ${setGlobalHeading(heading2CopySizeDesktop, heading2CopySizeMobile, heading2CopyWeight)}
                  `
                }
              
              @media only screen and (min-width: 768px) {
                .content-section .container,
                .content-section .content-module, 
                .container-gallery-section .gallery-carousel-content, 
                .product-integration-section .container, 
                .booking-section .booking-widget .container,
                .booking-section .booking-widget .container.no-wizard-title,
                .place-filter .filter-result-container .filter-result-wrapper .product-integration-section .product-integration-panel-single,
                .feature-stay-module,
                .standard-partner-module {
                  padding-top: calc(${moduleSpacing} - 12px);
                  padding-bottom: calc(${moduleSpacing} - 8px);
                }
                .product-integration-section .panel-style-3 .container,
                .place-filter .filter-result-container .filter-result-wrapper .product-integration-section .product-integration-panel-single{
                  padding-top: ${moduleSpacing};
                  padding-bottom: ${moduleSpacing};
                }
                .feature-stay-module, .standard-partner-module {
                  padding-bottom: ${moduleSpacing};
                }
                .place-filter {
                  padding-top: calc(${moduleSpacing} - 12px);
                  .filter-container{
                    padding-bottom: ${moduleSpacing}
                  }
                }
              }
              `;
  }
  private setFontFamily() {
    const { bodyFont } = this.data;
    if (!checkValue(bodyFont)) return '';
    else if (bodyFont === 'Expedia new - Reckless Neue Book / Repro Rounded')
      return `
      font-family: "Repro Rounded", "Centra No2", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif !important;
      .override-heading-font-family{
          font-family: "Reckless XPD", "Centra No2", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif !important;
      }
    `;
    else if (bodyFont === "Reckless XPD Book / Repro Rounded")
      return `
      font-family: "Repro Rounded", "Centra No2", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif !important;
      .override-heading-font-family{
          font-family: "Reckless XPD Book", "Centra No2", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif !important;
      }
    `;
    else if (bodyFont === 'Reckless Neue')
      return `
      .override-heading-font-family{
          font-family: "Reckless XPD", "Centra No2", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif !important;
      }
    `;
    else if (bodyFont === 'Wales Sans Headline / Centra No2')
      return `
      .override-heading-font-family{
          font-family: "Wales Sans Headline", "Centra No2", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif !important;
      }
    `;
    else if (bodyFont === 'Reckless XPD Light | Italic / Centra No2 Book | Medium | Bold')
    return `
    .override-heading-font-family{
        font-family: "Reckless XPD", "Centra No2", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif !important;
    }    
    h2.override-heading-font-family.cms-typo {

      letter-spacing: -1.9px !important;
    }
  `;
    else if (bodyFont === 'Reckless XPD Book / Centra No2')
      return `
      font-family: "Centra No2", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif !important;
      body{
        font-family: "Centra No2", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif !important;
      }
      .override-heading-font-family{
          font-family: "Reckless XPD Book", "Centra No2", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif !important;
      }    
    `;  
    else if (bodyFont === 'Tahoma / Centra No2')
      return `
      .override-heading-font-family {
        font-family: "Tahoma", "Centra No2", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif !important;
      }
    `;

    return `font-family: ${bodyFont.toLowerCase().split(' ').join('-')}`;
  }
  private brandStyle() {
    return brandCss(this.defaultSetting?.site?.brand, this.defaultSetting?.style?.bodyFontColor);
  }

  public Overrides() {
    const moduleCssOverrides = this.moduleCssOverrides();
    const primaryBtnStyles = this.primaryBtnStyles();
    const brandStyles = this.brandStyle();
    const setFontFamily = this.setFontFamily();
    const allOverrides = `${primaryBtnStyles}${brandStyles}${moduleCssOverrides}${setFontFamily}`;
    return allOverrides;
  }
}

export default ModuleStyles;
